module.exports = __webpack_public_path__ + "static/media/logo.c467e048.png";